/**
 * License Renewal.
 *
 * @group DRM
 *
 * @beta
 */
export const LICENSE_RENEWAL = 'license-renewal';
